export default __webpack_public_path__ + "static/media/breadcrumb-bg.fcd1f19b.jpg";